import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

const API_ROLES_URL = `${environment.apiUrl}/Roles`;

@Injectable({
    providedIn: 'root',
})
export class RoleService {
    constructor(private http: HttpClient) {}

    getRoles(): Observable<any> {
        return this.http.get(API_ROLES_URL + '/GetRoles');
    }

    addRole(input: any): Observable<any> {
        return this.http.post(API_ROLES_URL + '/AddRole', input);
    }
    updateRole(input: any): Observable<any> {
        return this.http.put(API_ROLES_URL + '/UpdateRole', input);
    }
    removeRole(id: number): Observable<any> {
        return this.http.delete(API_ROLES_URL + '/RemoveRole/' + id);
    }
}
